import { useWorkflowContext } from 'app-context/worflow/WorkflowContext';
import RightSlider from 'component/hoc/rightSlider/RightSlider';
import ConditionForm from 'component/organism/workflow/forms/condition/ConditionForm';
import { FormikProvider, useFormik } from 'formik';
import { isEqual } from 'lodash';
import React, { useEffect } from 'react';
import toast from 'react-hot-toast';
import * as Yup from 'yup';

const ConditionModal = ({
  isOpen,
  onClose,
  title,
  id,
  variableData,
  isError,
}) => {
  const {
    workflowData,
    setWorkflowData,
    selectedNode,
    initialWorkflowData,
    setIsChanged,
  } = useWorkflowContext();

  const formik = useFormik({
    initialValues: {
      match: selectedNode?.data?.match || 'all',
      workFlowNode_Condition: {
        variableId: selectedNode?.workFlowNode_Condition?.variableId || '',
        reassessIntent:
          selectedNode?.workFlowNode_Condition?.reassessIntent || false,
        allOtherConditions: {
          conditionType: true,
          isAllConditions:
            selectedNode?.workFlowNode_Condition?.isAllConditions || true,
          sourceHandle: `${id}-1`,
        },
        ifBlock: selectedNode?.workFlowNode_Condition?.ifBlock || {
          conditionType: true,
          value: selectedNode?.workFlowNode_Condition?.ifBlock?.value || '',
          operationId:
            selectedNode?.workFlowNode_Condition?.ifBlock?.operationId || 1,
          sourceHandle:
            selectedNode?.workFlowNode_Condition?.ifBlock?.sourceHandle ||
            `${id}-${0}`,
        },
        elseBlock: selectedNode?.workFlowNode_Condition?.elseBlock?.map(
          (q, index) => ({
            conditionType: true,
            value: q.value || '',
            operationId: q.operationId || 1,
            sourceHandle: q.sourceHandle || `${id}-${index + 2}`,
          })
        ) || [
          {
            conditionType: true,
            value: '',
            operationId: 1,
            sourceHandle: `${id}-2`,
          },
        ],
      },
    },
    enableReinitialize: true,
    validationSchema: Yup.object({
      match: Yup.string().required('Required'),
      workFlowNode_Condition: Yup.object({
        variableId: Yup.string().required('Variable is required'),
        reassessIntent: Yup.boolean(),
        allOtherConditions: Yup.boolean(),
        ifBlock: Yup.object().shape({
          value: Yup.string().required(),
          operationId: Yup.string().required('Operator is required'),
          sourceHandle: Yup.string().required(),
        }),
        elseBlock: Yup.array().of(
          Yup.object().shape({
            value: Yup.string(),
            operationId: Yup.string(),
            sourceHandle: Yup.string(),
          })
        ),
      }),
    }),
    onSubmit: (values, { setSubmitting, resetForm }) => {},
  });
  const handleSubmit = async () => {
    await formik.handleSubmit();
    try {
      setTimeout(() => {
        const updatedNodes = workflowData?.nodes?.map((node) =>
          node.id === id
            ? {
                ...node,
                workFlowNode_Condition: formik.values.workFlowNode_Condition,
                is_Error: isError,
              }
            : node
        );
        setWorkflowData((prev) => ({
          ...prev,
          nodes: updatedNodes,
        }));
        const initialNode = initialWorkflowData?.find(
          (node) => node?.id === id
        );
        if (initialNode) {
          const {
            allOtherConditions,
            elseBlock,
            ifBlock,
            reassessIntent,
            variableId,
          } = initialNode?.workFlowNode_Condition || {};
          const initialMessageObject = {
            variableId,
            reassessIntent,
            allOtherConditions: {
              conditionType: true,
              isAllConditions: allOtherConditions?.isAllConditions || true,
              sourceHandle: `${id}-1`,
            },
            ifBlock,
            elseBlock: elseBlock?.map((q, index) => ({
              conditionType: true,
              value: q.value || '',
              operationId: q.operationId || 1,
              sourceHandle: q.sourceHandle || `${id}-${index + 2}`,
            })) || [
              {
                conditionType: true,
                value: '',
                operationId: 1,
                sourceHandle: `${id}-2`,
              },
            ],
          };
          const currentValues = formik.values.workFlowNode_Condition;

          const changed = !isEqual(currentValues, initialMessageObject);
          setIsChanged((prev) => {
            const alreadyExists = prev?.includes(id);
            if (changed && !alreadyExists) {
              return [...prev, id];
            }
            if (!changed && alreadyExists) {
              return prev?.filter((nodeId) => nodeId !== id);
            }

            return prev;
          });
        }
        onClose();
        formik.resetForm();
      }, [100]);
    } catch {
      toast.error('Something went wrong');
    }
  };

  useEffect(() => {
    const updatedNodes = workflowData?.nodes?.map((node) =>
      node.id === id ? { ...node, is_Error: isError } : node
    );
    setWorkflowData((prev) => ({
      ...prev,
      nodes: updatedNodes,
    }));
  }, [isError]);

  // useEffect(() => {
  //   const edges = workflowData?.edges;
  //   const conditionSource =
  //     formik.values.workFlowNode_Condition?.allOtherConditions?.sourceHandle;
  //   const elseSources = formik.values.workFlowNode_Condition?.elseBlock?.map(
  //     (i) => i.sourceHandle
  //   );
  //   // Check if conditionSource exists in edges
  //   const conditionExists = edges.some(
  //     (edge) => edge.source === conditionSource
  //   );

  //   // Check if all elseSources exist in edges
  //   const filteredElseSources = elseSources.filter((source) =>
  //     edges.some((edge) => edge.source === source)
  //   );

  // }, [formik.values.workFlowNode_Condition]);
  useEffect(() => {
    if (isError) {
      formik.handleSubmit();
    }
  }, [isOpen]);

  return (
    <RightSlider
      title={title}
      action={{
        isOpen: isOpen,
        setIsOpen: handleSubmit,
      }}
    >
      <FormikProvider value={formik}>
        <ConditionForm
          variableData={variableData}
          id={id}
          setWorkflowData={setWorkflowData}
          workflowData={workflowData}
        />
      </FormikProvider>
    </RightSlider>
  );
};

export default ConditionModal;
